import { faChalkboardUser, faChartPie, faChevronRight, faChevronUp, faUser, faUserGear, faUsersGear } from '@fortawesome/free-solid-svg-icons';
import { faChartColumn, faChartArea, faChartLineUp } from '@fortawesome/sharp-solid-svg-icons';
import { faCalculatorSimple, faFileChartPie, faHourglassClock, faMobile } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from 'react-bootstrap';
import '../styles/reports.css';
import { useNavigate } from 'react-router';
import CourseUsagePreview from '../../../../src/assets/images/CourseUsagePreview.svg';
import AllAssignmentsPreview from '../../../../src/assets/images/AllAssignmentsPreview.svg';
import SingleAssignmentPreview from '../../../../src/assets/images/SingleAssignmentPreview.svg';
import TimeOnTaskPreview from '../../../../src/assets/images/timeOnTaskPreview.png';
import GrowthReportPreview from '../../../../src/assets/images/GrowthReportPreview.svg';
import MathSkillPreview from '../../../../src/assets/images/mathSkillPreview.svg';
import SelfStudyPreview from '../../../../src/assets/images/selfStudyPreview.png';
import LoginTrackReportPreview from '../../../../src/assets/images/loginTrackReportPreview.svg';
import ItemAnalysisReportPreview from '../../../../src/assets/images/itemAnalysisReportPreview.svg';
import CompanionAppUsagePreview from '../../../../src/assets/images/companionAppUsagePreview.png';
import { useState } from 'react';
import Modal from '../../../components/Modal';
import { useReportContext } from '../components/reportContext';
import { useSelector } from 'react-redux';
import { selectCurrentUserData } from '../../../features/authentication/authSlice';
import UserTypes from '../../../enums/userTypes';

const Reports = () => {
  const navigate = useNavigate();
  const [hoverIndex, setHoverIndex] = useState(-1);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const user = useSelector(selectCurrentUserData);
  const reportContext = useReportContext();
  reportContext.setSelectedCourseId(0);
  const canViewAdminOnlyReports = [UserTypes.SuperAdministrator, UserTypes.Sales, UserTypes.SuperSales, UserTypes.Trainer].includes(user?.UserType);
  
  const items = [
    {
      id: 'allAdminAssessmentsReport',
      icon: <FontAwesomeIcon icon={faUsersGear} />,
      title: 'All Admin Assessments Report',
      description: 'The All Admin Assessments Report shows student performance for published assessments, providing a breakdown',
      to: 'all-admin-assessments',
      comingSoon: false,
      adminOnly: false,
      previewImage: AllAssignmentsPreview
    },
    {
      id: 'singleAdminAssessmentReport',
      icon: <FontAwesomeIcon icon={faUserGear} />,
      title: 'Single Admin Assessment Report',
      description: 'The Single Admin Assessment Report shows student performance for published assessments, providing a breakdown',
      to: 'single-admin-assessment',
      comingSoon: false,
      adminOnly: false,
      previewImage: SingleAssignmentPreview
    },
    {
      id: 'allAssignmentsReport',
      icon: <FontAwesomeIcon icon={faChalkboardUser} />,
      title: 'All Assignments Report',
      description: 'The All Assignments Report shows student performance for individual assignments or for all assignments in a course',
      to: 'all-assignments',
      comingSoon: false,
      adminOnly: false,
      previewImage: AllAssignmentsPreview
    },
    {
      id: 'singleAssignmentReport',
      icon: <FontAwesomeIcon icon={faUser} />,
      title: 'Single Assignment Report',
      description: 'The Single Assignment Report shows student performance for individual assignments or for all assignments in a course',
      to: 'single-assignment',
      comingSoon: false,
      adminOnly: false,
      previewImage: SingleAssignmentPreview
    },
    {
      id: 'courseUsageReport',
      icon: <FontAwesomeIcon icon={faChartColumn} />,
      title: 'Course Usage Report',
      description: 'Course Usage Report shows how many questions students have answered, with separate counts for assignments',
      to: 'course-usage',
      comingSoon: false,
      adminOnly: false,
      previewImage: CourseUsagePreview
    },
    {
      id: 'timeOnTaskTrackingReport',
      icon: <FontAwesomeIcon icon={faHourglassClock} />,
      title: 'Time On Task Tracking Report',
      description: 'Activity Tracking reports on student activity for individual assignments/for all assignments in a course',
      to: 'time-on-task-tracking',
      comingSoon: false,
      adminOnly: false,
      previewImage: TimeOnTaskPreview
    },
    {
      id: 'loginTrackingReport',
      icon: <FontAwesomeIcon icon={faChartArea} />,
      title: 'Login Tracking Report',
      description: 'Login Tracking reports on student login, logout and idle times.',
      to: 'login-tracking',
      comingSoon: false,
      adminOnly: false,
      previewImage: LoginTrackReportPreview
    },
    {
      id: 'growthReport',
      icon: <FontAwesomeIcon icon={faChartLineUp} />,
      title: 'Growth Report',
      description: 'Teacher assignment\'s growth report',
      to: 'growth-report',
      comingSoon: false,
      adminOnly: false,
      previewImage: GrowthReportPreview
    },
    {
      id: 'itemAnalysisReport',
      icon: <FontAwesomeIcon icon={faChartPie} />,
      title: 'Item Analysis Report',
      description: 'A Report for comprehensive data comparison based on the work of Paul Bambrick-Santoyo',
      to: 'item-analysis',
      comingSoon: false,
      adminOnly: false,
      previewImage: ItemAnalysisReportPreview
    },
    {
      id: 'mathSkillsReport',
      icon: <FontAwesomeIcon icon={faCalculatorSimple} />,
      title: 'Math Skills Report',
      description: 'In the report, the math skills of the students are displayed.',
      to: 'math-skills',
      comingSoon: false,
      adminOnly: false,
      previewImage: MathSkillPreview
    },
    {
      id: 'selfStudyReport',
      icon: <FontAwesomeIcon icon={faFileChartPie} />,
      title: 'Self Study Report',
      description: 'The Self Study Report summarizes independent study sessions completed by students.',
      to: 'self-study',
      comingSoon: false,
      adminOnly: false,
      previewImage: SelfStudyPreview
    },
    {
      id: 'companionAppUsageReport',
      icon: <FontAwesomeIcon icon={faMobile} />,
      title: 'Companion App Usage Report',
      description: 'The Companion App Usage Report summarizes student activity on the companion app.',
      to: 'companion-app-usage',
      comingSoon: false,
      adminOnly: true,
      previewImage: CompanionAppUsagePreview
    }
  ];

  const visibleItems = items.filter((item) => !item.adminOnly || canViewAdminOnlyReports);

  return (
    <>
      <div className="white-card">
        <section className="welcome">
          <h2 className="primary-title">Reports</h2>
        </section>
        <Row>
          {visibleItems.map((item, index) => {
            const shouldOffsetItem = visibleItems.length % 4 === 3 && index === visibleItems.length - 3;
            return (
              <Col
                id={item.title}
                key={index}
                className= {`position-relative col-sm-6 col-md-4 col-lg-3 mb-4 ${shouldOffsetItem ? 'offset-lg-1' : ''} `}
              >
                {item.comingSoon && <div className="overlay">
                  <div className="overlay-message">
                      Coming Soon
                  </div>
                </div>
                }
                <div className='reportBox d-flex flex-column h-100'>
                  <div className={`preview-overlay d-flex justify-content-around ${hoverIndex == index?'fadeIn':'d-none'}`}>
                    <div className="overlay-image" style={{ backgroundImage: `url(${item.previewImage})` }}></div></div>
                  <div className={`d-flex flex-column align-items-center mb-2 mt-3 h-100 ${!item.comingSoon ? 'cursor-pointer':''} `} onClick={()=>navigate(item.to)} >
                    <span className="d-block mb-3 icon">{item.icon}</span>
                    <div className='title mb-2'>{item.title}</div>
                    <div className="mb-0 description">{item.description}</div>
                  </div>
                 
                  <div className='d-flex justify-content-between align-items-center p-2 previewBar w-100 cursor-pointer'
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(-1)}
                    onClick={()=> {setShowPreviewModal(true); setPreviewImage(item.previewImage);}}
                  >
                    <div className='p-text'>Preview Report</div>
                    <div><FontAwesomeIcon icon={hoverIndex == index ? faChevronUp : faChevronRight} color='#82A9E2' /></div>
                  </div>
                </div>            
              </Col>
            );
          })}
        </Row>
      </div>
      <Modal isOpen={showPreviewModal} onClose={()=>setShowPreviewModal(false)} titleName="Preview Report" contentWidth="60%">
        <div>
          <img className='w-100' src={previewImage}></img>
        </div>
      </Modal>
    </>
  );
};

export default Reports;
